import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'

import { Tips } from '@/components/common'
import { useEarlyPaymentDiscount } from '@/hooks'

export const EarlyPaymentDiscountInfo = (): JSX.Element | null => {
    const { t } = useTranslation()
    const { discountDate, loading } = useEarlyPaymentDiscount()

    if (loading) {
        return (
            <div className="animate-pulse">
                <div className="h-20 bg-gray-200 rounded-xl"></div>
            </div>
        )
    }

    // Even if there is an error or no date, show the fixed 5% message without date

    const formatDate = (dateString: string): string => {
        try {
            // Parse the date string as UTC to avoid timezone offset issues
            const [year, month, day] = dateString.split('-').map(Number)
            const date = new Date(year, month - 1, day)

            return format(date, "dd 'de' MMMM 'de' yyyy", { locale: es })
        } catch {
            return dateString
        }
    }

    const formattedDate = discountDate?.date
        ? formatDate(discountDate.date)
        : ''

    return (
        <Tips
            title={t('discounts.earlyPayment.title')}
            text={
                formattedDate
                    ? t('discounts.earlyPayment.description', {
                          percentage: discountDate?.percentage,
                          date: formattedDate
                      })
                    : t('discounts.earlyPayment.info')
            }
            banner="news"
            className="mt-4"
        />
    )
}
